import { render, staticRenderFns } from "./addDiscount.vue?vue&type=template&id=28838ebe&scoped=true"
import script from "./addDiscount.vue?vue&type=script&lang=js"
export * from "./addDiscount.vue?vue&type=script&lang=js"
import style0 from "./addDiscount.vue?vue&type=style&index=0&id=28838ebe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28838ebe",
  null
  
)

export default component.exports